// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class CustomListRequestMessage extends PFixMessage {
    constructor() {
        super(Message.CUSTOM_LIST_REQUEST);
    }
    setUserId(userID) {
        this.setFieldValue(FieldsFactory.FIELD_USER_ID, userID);
    }
    setListType(listType) {
        this.setFieldValue(FieldsFactory.FIELD_LIST_TYPE, listType);
    }
}
